import { render, staticRenderFns } from "./DeletionThankYou.vue?vue&type=template&id=b6191eb2"
import script from "./DeletionThankYou.vue?vue&type=script&lang=ts"
export * from "./DeletionThankYou.vue?vue&type=script&lang=ts"
import style0 from "./DeletionThankYou.vue?vue&type=style&index=0&id=b6191eb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports